module.exports = __webpack_public_path__ + "static/media/nft.206dff95.svg";